export const ColumnProp = Object.freeze({
    Name: 'name',
    Position: 'position',
    Hidden: 'hidden',
});
